import { Link } from "gatsby"
import React, { useState } from "react"
import '../styles/global.scss'
import { useMediaQuery } from 'react-responsive'
import ChinaIcon from './common/ChinaIcon'
import UkIcon from './common/UkIcon'

const Header = (props) => {
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1023px)' });
  const { storiesLink } = props;
  const [openNav, setOpenNav] = useState(false)

  const handleClick = () => {
    setOpenNav(!openNav)
  }

  return (
  <nav className="navbar is-transparent" role="navigation" aria-label="main navigation">
    <div className="navbar-brand">
      <a role="button" className={`navbar-burger burger ${openNav ? 'is-active' : ''}`} aria-label="menu" aria-expanded="false" 
         data-target="navbarBasicExample" onClick={handleClick}>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
      </a>
    </div>    
    <div className={`navbar-menu ${openNav ? 'is-active mobile-nav' : ''}`}>
      <div className="navbar-end has-text-weight-bold is-size-7">
        <div className="navbar-item py-3 mt-3">
          <Link className='header-link' to={`/`} activeClassName='nav-current-page'>Home</Link>
        </div>
        <div className="navbar-item py-3 mt-3">
          <Link className='header-link' to={`/about_us`} activeClassName='nav-current-page'>About Us</Link>
        </div>
        <div className="navbar-item py-3 mt-3 is-hoverable uses-dropdown">
          <span className='header-link' activeClassName='nav-current-page'>Our Work</span>
          <div className="navbar-dropdown">
            <a className="navbar-item drop-down-item">
              <Link className='navbar-item drop-down-item' to={`/restoration`} activeClassName='nav-current-page'>Restoration</Link>
            </a>
            <a className="navbar-item drop-down-item">
              <Link className='navbar-item drop-down-item' to={`/wildlife-rescue-centre`} activeClassName='nav-current-page'>Wildlife Rescue Centre</Link>
            </a>
            <a className="navbar-item drop-down-item">
              <Link className='navbar-item drop-down-item' to={`/campaigning`} activeClassName='nav-current-page'>Campaigning</Link>
            </a>
            <a className="navbar-item drop-down-item">
              <Link className='navbar-item drop-down-item' to={`/forest-protection`} activeClassName='nav-current-page'>Forest Protection</Link>
            </a>
          </div>
        </div>
        <div className="navbar-item py-3 mt-3">
          <Link className='header-link' to={isTabletOrMobile ? 'stories_index' : storiesLink} activeClassName='nav-current-page'>
            Stories
          </Link>
        </div>
        <div className="navbar-item py-3 mt-3">
          <Link className='header-link' to={`/visit_us`} activeClassName='nav-current-page'>Visit Us</Link>
        </div>
        <div className="navbar-item py-3 mt-3">
          <Link className='header-link' to={`/volunteer`} activeClassName='nav-current-page'>Volunteer</Link>
        </div>
        <div className="navbar-item py-3 mt-3">
          <Link className='header-link' to={`/contact`} activeClassName='nav-current-page'>Contact</Link>
        </div>
        <div className="navbar-item py-3 mt-3">
          <Link className='header-link' to={`/donate`} activeClassName='nav-current-page'>Donate</Link>
        </div>
        <div className="navbar-item py-3 mt-2">
          <div className="lg:mr-0 mr-5 bg-white rounded px-1 text-center flex flex-col items-center group relative">
            <span className="text-black text-tiny -mb-1">LANG</span>
            <div className="flex flex-col">
              <UkIcon width="25" />
              <span className="text-gray-600 text-tiny -mt-2">ENG</span>
            </div>
            <div className="items-center justify-center hidden group-hover:flex absolute px-1 py-1 rounded bg-gray-300"  style={{bottom: -40}}>
              <a href='https://canborneo-china.netlify.app/' target='_blank' rel="noopener noreferrer" className="flex flex-col">
                <ChinaIcon width="25" />
                <span className="text-gray-600 text-tiny -mt-1">CHI</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
  )
}

export default Header